"use client";

import Link from "next/link";
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useAuth } from "@/hooks/useAuth";
import { SocialFeatures } from "./SocialFeatures";

export const UserAvatar = () => {
  const { user, signOut } = useAuth();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const getInitial = (email: string) => {
    return email ? email.charAt(0).toUpperCase() : "";
  };

  const handleSignOut = () => {
    signOut();
    setIsDropdownOpen(false);
  };

  if (!user) {
    return null;
  }

  return (
    <div
      className="relative"
      style={{ zIndex: 9999 }}
      onClick={() => setIsDropdownOpen(true)}
      onMouseEnter={() => setIsDropdownOpen(true)}
      onMouseLeave={() => setIsDropdownOpen(false)}
    >
      <motion.div
        className="flex w-10 h-10 rounded-full items-center justify-center text-sm font-bold backdrop-blur-sm border-2 cursor-pointer"
        style={{
          background: "linear-gradient(45deg, #a8edea 0%, #fed6e3 100%)",
          color: "#2d1b69",
          boxShadow: "0 4px 20px rgba(168, 237, 234, 0.4)",
          border: "2px solid rgba(168, 237, 234, 0.5)",
        }}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
        whileHover={{
          scale: 1.1,
          boxShadow: "0 8px 30px rgba(168, 237, 234, 0.6)",
        }}
      >
        {getInitial(user.email)}
      </motion.div>

      <AnimatePresence>
        {isDropdownOpen && (
          <motion.div
            className="absolute top-12 right-0 w-max backdrop-blur-sm rounded-lg border-2 overflow-hidden"
            style={{
              background: "#1f1147",
              backdropFilter: "blur(20px)",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              boxShadow: "0 20px 60px rgba(0, 0, 0, 0.5)",
              zIndex: 9999,
            }}
            initial={{ opacity: 0, y: -10, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: -10, scale: 0.95 }}
            transition={{ duration: 0.2 }}
          >
            <div className="px-4 py-3 border-b border-white/10">
              <p className="text-sm font-medium text-white">{user.email}</p>
            </div>

            <div className="px-4 py-3">
              <SocialFeatures />
            </div>

            <div className="py-1">
              <Link href="/my-account">
                <motion.div
                  className="flex items-center px-4 py-2 text-sm text-white cursor-pointer"
                  whileHover={{
                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                  }}
                  transition={{ duration: 0.15 }}
                >
                  Account settings
                </motion.div>
              </Link>

              <motion.button
                onClick={handleSignOut}
                className="w-full flex items-center px-4 py-2 text-sm text-white cursor-pointer text-left"
                whileHover={{
                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                }}
                transition={{ duration: 0.15 }}
              >
                Sign Out
              </motion.button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
